import { render } from "./TransitaireDashboard.vue?vue&type=template&id=11e71be5&scoped=true&ts=true"
import script from "./TransitaireDashboard.vue?vue&type=script&lang=ts"
export * from "./TransitaireDashboard.vue?vue&type=script&lang=ts"

import "./TransitaireDashboard.vue?vue&type=style&index=0&id=11e71be5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e71be5"]])

export default __exports__